import api from "../../../components/api"
import { RecoveryComponentSettings } from "./recoveryComponent"

export type SetRecoveryComponentRequest = {
  enabled: boolean
  acceptedSurchargeDisclaimer: boolean
}

export const getRecoveryComponentSettings = async (): Promise<RecoveryComponentSettings> => {
  return (await api.get<RecoveryComponentSettings>(`/web/invoicing/settings/recovery-component`)).data
}

export const setRecoveryComponentEnabled = async (request: SetRecoveryComponentRequest): Promise<void> => {
  await api.post(`/web/invoicing/settings/recovery-component`, request)
}
